import { Breakpoint, useBreakpoint } from "@gik/core/hooks/CustomHooks";
import bemBlock from "@gik/core/utils/bemBlock";
import { getAssetsUrl } from "@gik/core/utils/LinkUtils";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { CreateClickedLocation } from "@gik/create/enums/CreateAnalyticsEnums";
import { translationKeys } from "@gik/homepage/i18n/en";
import i18n from "@gik/i18n";
import { CreatePageFor } from "@gik/ui-legacy/gik/CreatePageFor/CreatePageFor";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type React from "react";

const blockName = "give-footer";

function GiveFooterComp(): React.ReactElement {
	const bem = bemBlock(blockName);
	const isMd = useBreakpoint(Breakpoint.MD);

	return (
		<PageSection
			className={bem(null)}
			variant={"aqua"}
			noPadTop
			noPadBottom
			background={
				isMd
					? `${getAssetsUrl()}shop/friendsDesktop.png`
					: `${getAssetsUrl()}shop/friendsMobile.png`
			}
			decoration="flutter"
			decorationPlacement="right"
		>
			<main className={bem("copy")}>
				<h2 className={bem("title")}>
					{i18n.t(translationKeys.createPageTitle).toString()}
				</h2>
				<p className={bem("content")}>
					{i18n.t(translationKeys.createPageContent).toString()}
				</p>

				<CreatePageFor trackId={CreateClickedLocation.SHOP_BOTTOM} />
			</main>
		</PageSection>
	);
}

export const GiveFooter = withComponentErrorBoundary(GiveFooterComp);
